import { render, staticRenderFns } from "./PelleGalaxyGeneratorPanel.vue?vue&type=template&id=60277fd4&scoped=true"
import script from "./PelleGalaxyGeneratorPanel.vue?vue&type=script&lang=js"
export * from "./PelleGalaxyGeneratorPanel.vue?vue&type=script&lang=js"
import style0 from "./PelleGalaxyGeneratorPanel.vue?vue&type=style&index=0&id=60277fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60277fd4",
  null
  
)

export default component.exports